// Vendor imports
const classNames = require('classnames')
const PropTypes = require('prop-types')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
const { pluralize } = require('shared/string-utils')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const { eventHandler } = require('client-v2/common/utils/events')
const UserAvatar = require('client-v2/common/components/user-avatar')
const { collectionProfileHref } = require('client-v2/common/models/collection/actions')
const { userProfileHref } = require('client-v2/common/models/user/actions')

// String helpers
const followers = pluralize('follower')

// BEM Block entity definition
const bem = BemEntity('ArticleProfileCollectionsItem')

function ArticleProfileCollectionsItem(props) {
  const { user } = props.item
  const followerCount = user['follower_count'] || 0
  const onUserClick = eventHandler(props.onUserNavigate, { user })

  return (
    tag('section', {
      className: classNames(
        props.className,
        bem.block()
      )
    },
      tag(UserAvatar, {
        className: bem.element('user-icon'),
        href: true,
        user,
        onClick: onUserClick
      }),

      tag('a', {
        className: bem.element('user-href'),
        href: userProfileHref(user),
        onClick: onUserClick
      },
        `@${user.username}`
      ),

      tag('div', {
        className: bem.element('follower-count')
      },
        followerCount.toLocaleString(),
        ' ',
        followers(followerCount)
      ),

      tag(CollectionsList, {
        item: props.item,
        onCollectionNavigate: props.onCollectionNavigate
      })
    )
  )
}

ArticleProfileCollectionsItem.propTypes = {
  // Values
  className: PropTypes.string,
  item: PropTypes.object.isRequired,
  // Callbacks
  onCollectionNavigate: PropTypes.func.isRequired,
  onUserNavigate: PropTypes.func.isRequired
}

module.exports = ArticleProfileCollectionsItem

// BEM Block entity Element components

function CollectionsList(props) {
  const [ first, ...rest ] = props.item.collections
  return (
    tag('div', {
      className: bem.element('collections')
    },
      'Added to ',
      tag(Collection, {
        collection: first,
        onCollectionNavigate: props.onCollectionNavigate
      }),
      tag(RestCollections, {
        restCollections: rest,
        onCollectionNavigate: props.onCollectionNavigate
      })
    )
  )
}

function Collection(props) {
  const { collection } = props
  return (
    tag('a', {
      className: bem.element('collection-href'),
      href: collectionProfileHref(collection),
      onClick: eventHandler(props.onCollectionNavigate, { collection })
    },
      collection.name
    )
  )
}

function RestCollections(props) {
  const [ isExpanded, setExpanded ] = React.useState(false)
  const { restCollections } = props
  const restCount = restCollections.length
  if (!restCount) {
    return null
  }
  if (!isExpanded) {
    return tag([
      ' and ',
      tag('button', {
        className: bem.element('collections-expand'),
        onClick: () => setExpanded(true)
      },
        `${restCollections.length} more`
      )
    ])
  }
  return tag(restCollections.map((collection, index) => (
    tag([
      (restCount > 1) ? ',' : null,
      ' ',
      (index === restCount - 1) ? 'and ' : null,
      tag(Collection, {
        collection,
        onCollectionNavigate: props.onCollectionNavigate
      })
    ])
  )))
}
